import { RunBlockStatus } from 'shared/hooks/useReportProgress';

export const getSectionStatus = (
  statuses: RunBlockStatus[]
): RunBlockStatus => {
  if (statuses.every(status => status === 'ready')) {
    return 'ready';
  }

  if (statuses.some(status => status === 'in-progress')) {
    return 'in-progress';
  }

  return 'queued';
};
